module.exports = __webpack_public_path__ + "img/DIZ_extern.26f7ef4c.jpg";